import { Tag } from 'antd';
import { useTranslation } from 'react-i18next';

import type { ShipmentStatus, UpdStatus } from '@/api/generated/model';
import { SHIPMENT_STATUS_COLOR, UPD_STATUS_COLOR, type StatusKind } from '@/lib/statuses';

function StatusTag({
  kind,
  status,
  color,
  label,
}: {
  kind: StatusKind;
  status: string;
  color: string;
  label?: string | undefined;
}) {
  const { t } = useTranslation();
  return (
    <Tag color={color} title={t(`status.${kind}.${status}.hint`)}>
      {label ?? t(`status.${kind}.${status}.label`)}
    </Tag>
  );
}

/** clientName — для «Отгружено клиенту X» (формулировка ТЗ) у статуса shipped. */
export function ShipmentStatusTag({
  status,
  clientName,
}: {
  status: ShipmentStatus;
  clientName?: string | undefined;
}) {
  const { t } = useTranslation();
  const label =
    status === 'shipped' && clientName
      ? t('shipments.shippedTo', { client: clientName })
      : undefined;
  return (
    <StatusTag
      kind="shipment"
      status={status}
      color={SHIPMENT_STATUS_COLOR[status]}
      label={label}
    />
  );
}

export function UpdStatusTag({ status }: { status: UpdStatus }) {
  return <StatusTag kind="upd" status={status} color={UPD_STATUS_COLOR[status]} />;
}
